import { toDisplayString as _toDisplayString, createVNode as _createVNode, createTextVNode as _createTextVNode, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = {
  id: "passwordHelpBlock",
  class: "form-text"
}
const _hoisted_2 = { id: "password-hint-list" }
const _hoisted_3 = { id: "sub-list" }

export function render(_ctx, _cache, $props, $setup, $data, $options) {
  return (_openBlock(), _createBlock("small", _hoisted_1, [
    _createVNode("ul", _hoisted_2, [
      _createVNode("li", null, _toDisplayString(_ctx.translations.twelveCharacters), 1),
      _createVNode("li", null, [
        _createTextVNode(_toDisplayString(_ctx.translations.threeOutOfFourCategories) + " ", 1 /* TEXT */),
        _createVNode("ul", _hoisted_3, [
          _createVNode("li", null, _toDisplayString(_ctx.translations.lowercase), 1),
          _createVNode("li", null, _toDisplayString(_ctx.translations.uppercase), 1),
          _createVNode("li", null, _toDisplayString(_ctx.translations.specialCharacters), 1),
          _createVNode("li", null, _toDisplayString(_ctx.translations.numbers), 1)
        ])
      ]),
      _createVNode("li", null, _toDisplayString(_ctx.translations.avoidRepeatingCharacters), 1),
      _createVNode("li", null, _toDisplayString(_ctx.translations.avoidConsecutiveKeyboardPatterns), 1)
    ])
  ]))
}